import { Component, OnInit, OnDestroy, DoCheck } from '@angular/core';
import { RightSideDrawerService } from '../right-side-drawer.service';

@Component({
  selector: 'time-survey-employee-list',
  templateUrl: './time-survey-employee-list.component.html',
  styleUrls: ['./time-survey-employee-list.component.scss']
})

export class TimeSurveyEmployeeList implements OnInit, OnDestroy{
  masterData: any;
  drawerName: string = '';
  employeeList:{name:string, taxPeriod:string}[];

  constructor(public rightSideDrawerService: RightSideDrawerService) {
  }

  ngOnInit() {
    this.masterData = this.rightSideDrawerService.singleRowEditData;
    this.employeeList = this.masterData.rowData;
    this.drawerName = this.masterData.drawerName;
  }

  ngOnDestroy() {
    this.rightSideDrawerService.closeRightSideDrawer();
  }
  
}
